/* Shreya — collections grid: "Explore +" toggles a product panel under the row. */
(() => {
  if (customElements.get('collections-explorer')) return;

  class CollectionsExplorer extends HTMLElement {
    connectedCallback() {
      this.addEventListener('click', (event) => {
        const toggle = event.target.closest('[data-explore]');
        if (toggle) { this.toggle(toggle); return; }
        const close = event.target.closest('[data-explore-close]');
        if (close) {
          const panel = close.closest('[data-explore-panel]');
          const owner = panel && this.querySelector(`[aria-controls="${panel.id}"]`);
          if (owner) { this.toggle(owner, false); owner.focus(); }
        }
      });
      this.addEventListener('keydown', (event) => {
        if (event.key !== 'Escape') return;
        const panel = event.target.closest('[data-explore-panel]');
        const owner = panel && this.querySelector(`[aria-controls="${panel.id}"]`);
        if (owner) { this.toggle(owner, false); owner.focus(); }
      });
    }

    toggle(button, force) {
      const panel = document.getElementById(button.getAttribute('aria-controls'));
      if (!panel) return;
      const open = typeof force === 'boolean' ? force : button.getAttribute('aria-expanded') !== 'true';

      if (open) {
        this.querySelectorAll('[data-explore][aria-expanded="true"]').forEach((other) => {
          if (other !== button) this.toggle(other, false);
        });
      }
      button.setAttribute('aria-expanded', String(open));
      panel.hidden = !open;

      if (open) {
        if (window.Theme && window.Theme.initReveal) window.Theme.initReveal(panel);
        const box = panel.getBoundingClientRect();
        if (box.bottom > window.innerHeight) {
          panel.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
        }
      }
    }
  }

  customElements.define('collections-explorer', CollectionsExplorer);
})();
